var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import Theme from '../Theme';
import { toNumber, toRound, toMoney, toPercentage, toDate, toTime, toDateTime, toMoneyDecimal } from 'helpers/Format';
class Text extends Component {
    format(text) {
        const { number: _number, round, money, moneyData, percentage, date, time, dateTime } = this.props;
        if (_number)
            return toNumber(text);
        if (round)
            return toRound(text);
        if (money) {
            if (moneyData)
                return toMoneyDecimal(text, moneyData);
            return toMoney(text);
        }
        if (percentage)
            return toPercentage(text);
        if (date)
            return toDate(text);
        if (time)
            return toTime(text);
        if (dateTime)
            return toDateTime(text);
        return text;
    }
    render() {
        const _a = this.props, { children, style, big, small, lines, center, right, primary, color } = _a, props = __rest(_a, ["children", "style", "big", "small", "lines", "center", "right", "primary", "color"]);
        delete props.moneyData;
        delete props.money;
        let text = this.format(children);
        return (React.createElement("p", Object.assign({}, props, { 
            /*numberOfLines={lines}*/
            style: Object.assign({ fontFamily: Theme.fontFamily, fontSize: (big && Theme.fontSize.big) ||
                    (small && Theme.fontSize.small) ||
                    Theme.fontSize.regular, lineHeight: (big && Theme.line.big) ||
                    (small && Theme.line.small) ||
                    Theme.line.regular, color: primary ? Theme.color.primary : color ? color : Theme.color.secondary, textAlign: center ? 'center' : right ? 'right' : undefined, textAlignVertical: 'center' }, style) }), text));
    }
}
export default Text;



//////////////////
// WEBPACK FOOTER
// ./src/elements/Text.tsx
// module id = 49
// module chunks = 0